import React, { useEffect } from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import Hero from "../components/home/Hero";
import About from "../components/home/About";
import AffordableCare from "../components/home/AffordableCare";
import NurseCredentials from "../components/home/NurseCredentials";
import Values from "../components/home/Values";
import Services from "../components/home/Services";
import Team from "../components/home/Team";
import WhyChoose from "../components/home/WhyChoose";
import Pricing from "../components/home/Pricing";
import AppointmentForm from "../components/home/AppointmentForm";
import Testimonials from "../components/home/Testimonials";

const Home = () => {
  useEffect(() => {
    document.title = "Moggies & Doggies Veterinary Care";
  }, []);

  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <Hero />
        <About />
        <AffordableCare />
        <NurseCredentials />
        <Values />
        <Services />
        <Team />
        <WhyChoose />
        <Pricing />
        <AppointmentForm />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
